import { AkebonoCoreModule } from '@akebono/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';

import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { AutoLotsFilterComponent } from './auto-lots-filter.component';
import { CreateUserFilterPresetModalComponent } from './components/create-user-filter-preset-modal/create-user-filter-preset-modal.component';
import { UserFilterPresetsComponent } from './components/user-filter-presets/user-filter-presets.component';
import { AutoLotsFilterGuideModule } from '../../guides/auto-lots-filter-guide/auto-lots-filter-guide.module';
import { GuideModule } from '../guide/guide.module';

@NgModule({
  declarations: [
    AutoLotsFilterComponent,
    UserFilterPresetsComponent,
    CreateUserFilterPresetModalComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    TranslateModule,
    AkebonoCoreModule,
    BrowserAnimationsModule,
    NzButtonModule,
    NzModalModule,
    NzFormModule,
    NzInputModule,
    NzAlertModule,
    NzCollapseModule,
    NzSkeletonModule,
    NzSpinModule,
    NzCheckboxModule,
    NzDatePickerModule,
    NzSelectModule,
    NzPopconfirmModule,
    NzToolTipModule,
    NzIconModule,
    AutoLotsFilterGuideModule,
    GuideModule,
  ],
  exports: [AutoLotsFilterComponent],
})
export class AutoLotsFilterModule {}
